import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=561f970b&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=ts"
export * from "./AddRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f970b",
  null
  
)

export default component.exports